module.exports = __webpack_public_path__ + "static/media/favicon.611f753b.svg";